// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file profile_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ForeignProfile, ProfileData, ProfileRegenerateData } from "./profile_pb";
import { file_profile } from "./profile_pb";
import type { VaultCreationData } from "./vault_service_pb";
import { file_vault_service } from "./vault_service_pb";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file profile_service.proto.
 */
export const file_profile_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_profile, file_vault_service, file_sync_update]);

/**
 * @generated from message domain.CreatePrivateProfileRequest
 */
export type CreatePrivateProfileRequest = Message<"domain.CreatePrivateProfileRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: domain.ProfileData private_profile = 2;
   */
  privateProfile?: ProfileData | undefined;

  /**
   * @generated from field: domain.VaultCreationData private_vault = 3;
   */
  privateVault?: VaultCreationData | undefined;
};

/**
 * Describes the message domain.CreatePrivateProfileRequest.
 * Use `create(CreatePrivateProfileRequestSchema)` to create a new message.
 */
export const CreatePrivateProfileRequestSchema: GenMessage<CreatePrivateProfileRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 0);

/**
 * @generated from message domain.CreatePrivateProfileResponse
 */
export type CreatePrivateProfileResponse = Message<"domain.CreatePrivateProfileResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string private_profile_id = 2;
   */
  privateProfileId: string;

  /**
   * @generated from field: string private_vault_id = 3;
   */
  privateVaultId: string;
};

/**
 * Describes the message domain.CreatePrivateProfileResponse.
 * Use `create(CreatePrivateProfileResponseSchema)` to create a new message.
 */
export const CreatePrivateProfileResponseSchema: GenMessage<CreatePrivateProfileResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 1);

/**
 * @generated from message domain.DeletePrivateProfileRequest
 */
export type DeletePrivateProfileRequest = Message<"domain.DeletePrivateProfileRequest"> & {
  /**
   * @generated from field: string private_profile_id = 1;
   */
  privateProfileId: string;
};

/**
 * Describes the message domain.DeletePrivateProfileRequest.
 * Use `create(DeletePrivateProfileRequestSchema)` to create a new message.
 */
export const DeletePrivateProfileRequestSchema: GenMessage<DeletePrivateProfileRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 2);

/**
 * @generated from message domain.DeletePrivateProfileResponse
 */
export type DeletePrivateProfileResponse = Message<"domain.DeletePrivateProfileResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeletePrivateProfileResponse.
 * Use `create(DeletePrivateProfileResponseSchema)` to create a new message.
 */
export const DeletePrivateProfileResponseSchema: GenMessage<DeletePrivateProfileResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 3);

/**
 * @generated from message domain.RegenerateProfilesRequest
 */
export type RegenerateProfilesRequest = Message<"domain.RegenerateProfilesRequest"> & {
  /**
   * @generated from field: repeated domain.ProfileRegenerateData profiles = 1;
   */
  profiles: ProfileRegenerateData[];
};

/**
 * Describes the message domain.RegenerateProfilesRequest.
 * Use `create(RegenerateProfilesRequestSchema)` to create a new message.
 */
export const RegenerateProfilesRequestSchema: GenMessage<RegenerateProfilesRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 4);

/**
 * @generated from message domain.RegenerateProfilesResponse
 */
export type RegenerateProfilesResponse = Message<"domain.RegenerateProfilesResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.RegenerateProfilesResponse.
 * Use `create(RegenerateProfilesResponseSchema)` to create a new message.
 */
export const RegenerateProfilesResponseSchema: GenMessage<RegenerateProfilesResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 5);

/**
 * @generated from message domain.ListProfilesRequest
 */
export type ListProfilesRequest = Message<"domain.ListProfilesRequest"> & {
  /**
   * @generated from field: repeated string profile_ids = 1;
   */
  profileIds: string[];
};

/**
 * Describes the message domain.ListProfilesRequest.
 * Use `create(ListProfilesRequestSchema)` to create a new message.
 */
export const ListProfilesRequestSchema: GenMessage<ListProfilesRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 6);

/**
 * @generated from message domain.ListProfilesResponse
 */
export type ListProfilesResponse = Message<"domain.ListProfilesResponse"> & {
  /**
   * @generated from field: repeated domain.ForeignProfile profiles = 1;
   */
  profiles: ForeignProfile[];
};

/**
 * Describes the message domain.ListProfilesResponse.
 * Use `create(ListProfilesResponseSchema)` to create a new message.
 */
export const ListProfilesResponseSchema: GenMessage<ListProfilesResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 7);

/**
 * @generated from message domain.ProfileRequestEmailChangeRequest
 */
export type ProfileRequestEmailChangeRequest = Message<"domain.ProfileRequestEmailChangeRequest"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message domain.ProfileRequestEmailChangeRequest.
 * Use `create(ProfileRequestEmailChangeRequestSchema)` to create a new message.
 */
export const ProfileRequestEmailChangeRequestSchema: GenMessage<ProfileRequestEmailChangeRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 8);

/**
 * @generated from message domain.ProfileRequestEmailChangeResponse
 */
export type ProfileRequestEmailChangeResponse = Message<"domain.ProfileRequestEmailChangeResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: bool verification_email_sent = 2;
   */
  verificationEmailSent: boolean;
};

/**
 * Describes the message domain.ProfileRequestEmailChangeResponse.
 * Use `create(ProfileRequestEmailChangeResponseSchema)` to create a new message.
 */
export const ProfileRequestEmailChangeResponseSchema: GenMessage<ProfileRequestEmailChangeResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 9);

/**
 * @generated from message domain.ProfileCancelEmailChangeRequest
 */
export type ProfileCancelEmailChangeRequest = Message<"domain.ProfileCancelEmailChangeRequest"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;
};

/**
 * Describes the message domain.ProfileCancelEmailChangeRequest.
 * Use `create(ProfileCancelEmailChangeRequestSchema)` to create a new message.
 */
export const ProfileCancelEmailChangeRequestSchema: GenMessage<ProfileCancelEmailChangeRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 10);

/**
 * @generated from message domain.ProfileCancelEmailChangeResponse
 */
export type ProfileCancelEmailChangeResponse = Message<"domain.ProfileCancelEmailChangeResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.ProfileCancelEmailChangeResponse.
 * Use `create(ProfileCancelEmailChangeResponseSchema)` to create a new message.
 */
export const ProfileCancelEmailChangeResponseSchema: GenMessage<ProfileCancelEmailChangeResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 11);

/**
 * @generated from message domain.VerifyEmailAddressRequest
 */
export type VerifyEmailAddressRequest = Message<"domain.VerifyEmailAddressRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message domain.VerifyEmailAddressRequest.
 * Use `create(VerifyEmailAddressRequestSchema)` to create a new message.
 */
export const VerifyEmailAddressRequestSchema: GenMessage<VerifyEmailAddressRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 12);

/**
 * @generated from message domain.VerifyEmailAddressResponse
 */
export type VerifyEmailAddressResponse = Message<"domain.VerifyEmailAddressResponse"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message domain.VerifyEmailAddressResponse.
 * Use `create(VerifyEmailAddressResponseSchema)` to create a new message.
 */
export const VerifyEmailAddressResponseSchema: GenMessage<VerifyEmailAddressResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 13);

/**
 * @generated from message domain.ClaimWithStartCodeRequest
 */
export type ClaimWithStartCodeRequest = Message<"domain.ClaimWithStartCodeRequest"> & {
  /**
   * @generated from field: string start_code = 2;
   */
  startCode: string;

  /**
   * @generated from field: string profile_id = 3;
   */
  profileId: string;
};

/**
 * Describes the message domain.ClaimWithStartCodeRequest.
 * Use `create(ClaimWithStartCodeRequestSchema)` to create a new message.
 */
export const ClaimWithStartCodeRequestSchema: GenMessage<ClaimWithStartCodeRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 14);

/**
 * @generated from message domain.ClaimWithStartCodeResponse
 */
export type ClaimWithStartCodeResponse = Message<"domain.ClaimWithStartCodeResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message domain.ClaimWithStartCodeResponse.
 * Use `create(ClaimWithStartCodeResponseSchema)` to create a new message.
 */
export const ClaimWithStartCodeResponseSchema: GenMessage<ClaimWithStartCodeResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 15);

/**
 * @generated from message domain.GetProfileInfoRequest
 */
export type GetProfileInfoRequest = Message<"domain.GetProfileInfoRequest"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;
};

/**
 * Describes the message domain.GetProfileInfoRequest.
 * Use `create(GetProfileInfoRequestSchema)` to create a new message.
 */
export const GetProfileInfoRequestSchema: GenMessage<GetProfileInfoRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 16);

/**
 * @generated from message domain.GetProfileInfoResponse
 */
export type GetProfileInfoResponse = Message<"domain.GetProfileInfoResponse"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;

  /**
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * @generated from field: string organization_icon = 3;
   */
  organizationIcon: string;
};

/**
 * Describes the message domain.GetProfileInfoResponse.
 * Use `create(GetProfileInfoResponseSchema)` to create a new message.
 */
export const GetProfileInfoResponseSchema: GenMessage<GetProfileInfoResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 17);

/**
 * @generated from message domain.CheckProfileStartCodeRequest
 */
export type CheckProfileStartCodeRequest = Message<"domain.CheckProfileStartCodeRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * May be provided as an alternative to email
   *
   * @generated from field: string profile_id = 3;
   */
  profileId: string;

  /**
   * @generated from field: string start_code = 2;
   */
  startCode: string;
};

/**
 * Describes the message domain.CheckProfileStartCodeRequest.
 * Use `create(CheckProfileStartCodeRequestSchema)` to create a new message.
 */
export const CheckProfileStartCodeRequestSchema: GenMessage<CheckProfileStartCodeRequest> = /*@__PURE__*/
  messageDesc(file_profile_service, 18);

/**
 * @generated from message domain.CheckProfileStartCodeResponse
 */
export type CheckProfileStartCodeResponse = Message<"domain.CheckProfileStartCodeResponse"> & {
};

/**
 * Describes the message domain.CheckProfileStartCodeResponse.
 * Use `create(CheckProfileStartCodeResponseSchema)` to create a new message.
 */
export const CheckProfileStartCodeResponseSchema: GenMessage<CheckProfileStartCodeResponse> = /*@__PURE__*/
  messageDesc(file_profile_service, 19);

/**
 * ProfileService provides methods for handling user accounts.
 *
 * @generated from service domain.ProfileService
 */
export const ProfileService: GenService<{
  /**
   * errors:
   * - EmailTaken (20100): email address taken
   * - InvalidEmail (20101): invalid email address
   * - NotAllowedForUserType (20470)
   * - ProfilesLocked (20451): user's profiles are locked and already has a login profile
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - ProfileNotFound (70400): account is not profile enabled
   * - ProfileAlreadyEnabled (70401): private profile already exists
   * - MissingProfileAuthenticatorLock (70410): a profile lock is missing for an authenticator
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ProfileService.CreatePrivate
   */
  createPrivate: {
    methodKind: "unary";
    input: typeof CreatePrivateProfileRequestSchema;
    output: typeof CreatePrivateProfileResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - ProfileNotFound (70400): profile could not be found by id
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ProfileService.DeletePrivate
   */
  deletePrivate: {
    methodKind: "unary";
    input: typeof DeletePrivateProfileRequestSchema;
    output: typeof DeletePrivateProfileResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - VaultOutOfSync (50100): generation_id does not match for some vault
   * - VaultNotFound (50400): some vault profile lock had an unknown vault_id
   * - MissingLock (70510): missing locks for one or more authenticators
   * - ProfileNotFound (70400): some profile could not be found by id
   * - MissingProfileLock (70410): missing profile locks for one or more authenticators
   * - ProfileOutOfSync (70411): key_generation_id does not match for some profile
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ProfileService.Regenerate
   */
  regenerate: {
    methodKind: "unary";
    input: typeof RegenerateProfilesRequestSchema;
    output: typeof RegenerateProfilesResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - ProfileNotFound (70400): if any profile id could not be found
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ProfileService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListProfilesRequestSchema;
    output: typeof ListProfilesResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - InvalidEmail (20101)
   * - EmailTaken (20100)
   * - ProfileNotFound (70400): profile doesn't exist or can't have an email address
   * - NotAllowedForProfile (70433): profile has a parent organization profile
   * - Internal (10500)
   *
   * @generated from rpc domain.ProfileService.RequestEmailChange
   */
  requestEmailChange: {
    methodKind: "unary";
    input: typeof ProfileRequestEmailChangeRequestSchema;
    output: typeof ProfileRequestEmailChangeResponseSchema;
  },
  /**
   * errors:
   * - PermissionDenied (10100): email change may not be cancelled (in semi-verified state)
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - ProfileNotFound (70400): profile doesn't exist or can't have an email address
   * - Internal (10500)
   *
   * @generated from rpc domain.ProfileService.CancelEmailChange
   */
  cancelEmailChange: {
    methodKind: "unary";
    input: typeof ProfileCancelEmailChangeRequestSchema;
    output: typeof ProfileCancelEmailChangeResponseSchema;
  },
  /**
   * errors:
   * - PermissionDenied (10100): the credentials provided didn't match the verification token
   * - InvalidVerificationToken (20460): the verification token provided is invalid or outdated or the email has been verified for another account
   * - Internal (10500): internal server error
   * This endpoint can be called with or without credentials. If credentials are given, they must
   * match with the verification token.
   *
   * @generated from rpc domain.ProfileService.VerifyEmailAddress
   */
  verifyEmailAddress: {
    methodKind: "unary";
    input: typeof VerifyEmailAddressRequestSchema;
    output: typeof VerifyEmailAddressResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - ProfilesLocked (20451): user org org has profiles locked flag, and user already has a logins profile
   * - ProfileNotFound (70400): profile not found, or is not an organization profile
   * - ProfileAlreadyConnected (70402)
   * - ProfileStartCodeInactive (70403)
   * - UserAlreadyInOrganization (60401)
   * - StartCodeInvalid (70430)
   * - StartCodeBlocked (70431)
   * - EmailTaken (20100)
   * - AuditlogSubmissionError (90500)
   * - Internal (10500)
   *
   * @generated from rpc domain.ProfileService.ClaimWithStartCode
   */
  claimWithStartCode: {
    methodKind: "unary";
    input: typeof ClaimWithStartCodeRequestSchema;
    output: typeof ClaimWithStartCodeResponseSchema;
  },
  /**
   * errors:
   * - ProfileNotFound (70400)
   * - Internal (10500)
   *
   * @generated from rpc domain.ProfileService.GetProfileInfo
   */
  getProfileInfo: {
    methodKind: "unary";
    input: typeof GetProfileInfoRequestSchema;
    output: typeof GetProfileInfoResponseSchema;
  },
  /**
   * errors:
   * - InvalidEmail (20101)
   * - EmailInviteNotActive (20106)
   * - ProfileNotFound (70400)
   * - StartCodeInvalid (70430)
   * - StartCodeBlocked (70431)
   * - EmailInviteNotActive (20106)
   * - BadRequest (10400): both email and profile_id set
   *
   * @generated from rpc domain.ProfileService.CheckStartCode
   */
  checkStartCode: {
    methodKind: "unary";
    input: typeof CheckProfileStartCodeRequestSchema;
    output: typeof CheckProfileStartCodeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_profile_service, 0);

